import React from 'react';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import * as Sentry from '@sentry/nextjs';
import Link from 'next/link';

import styles from './styles.module.scss';

import { withLayoutAndSession } from '@utils/hocs';
import { PageWithProvidersAndLayout } from '@utils/types/nextApp';
import { StaticPageType } from '@utils/types/staticPages';
import { getStaticPages } from '@api/global/getStaticPages';

type Props = {
  staticPages: StaticPageType[];
};

const HostInformation: PageWithProvidersAndLayout<Props> = (props) => {
  const { staticPages } = props;

  return (
    <>
      <Head>
        <title>Host Information</title>
      </Head>

      <main className={styles.hostInformation}>
        <h1>Host Information</h1>

        <div className={styles.hostInformation__content}>
          {staticPages.map((page) => (
            <Link key={page.slug.current} href={`/s/${page.slug.current}`}>
              <a>{page.title}</a>
            </Link>
          ))}
        </div>
      </main>
    </>
  );
};

export const getStaticProps: GetStaticProps<any> = async () => {
  try {
    const staticPages = await getStaticPages();
    return {
      props: {
        staticPages: staticPages.filter(
          (page) => page.includeInHostInformation
        ),
      },
      revalidate: 30,
    };
  } catch (error) {
    Sentry.captureException(error);
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    };
  }
};

export default withLayoutAndSession(HostInformation, {
  headerProps: { theme: 'white' },
  footerProps: { theme: 'white' },
});
